import { UserProfile, UserProfileDTO } from "models/user/UserProfile";

export class UserDTO {
  public email: string = "";
  public roles: string[] = [];
  public profiles?: UserProfileDTO[];
}

export class User {
  private static readonly roles = {
    admin: "ADMIN_ROLE",
    partner: "PARTNER_ROLE"
  };

  private _email: string;
  private _roles: string[];
  private _profiles?: UserProfile[];

  constructor(user: UserDTO) {
    this._email = user.email;
    this._profiles = (user.profiles || []).map(
      (userProfile: UserProfileDTO) => new UserProfile(userProfile)
    );
    this._roles = user.roles || [];
  }

  public get email(): string {
    return this._email;
  }

  public hasRole(role: string): boolean {
    return this._roles.includes(role);
  }

  public isAdmin() {
    return this._roles.includes(User.roles.admin);
  }

  public isPartner() {
    return this._roles.includes(User.roles.partner);
  }
}
